import { useRouter } from "next/router";

import { type ContentLocale, toContentLocale } from "@/i18n/config";

/**
 * The content language of the page being viewed: `router.locale`, except that
 * `/en-us` reads `en` (WHO-5766). Use it, not `router.locale`, wherever the
 * locale picks content: a language-keyed map, a Strapi `locale:`, the gateway's
 * `lang`, the search service's `lang`, a localized path word. Keep
 * `router.locale` for routing itself (links, `router.push({ locale })`) and for
 * `Intl` formatting, where `en-us` is the right answer.
 */
export const useContentLocale = (): ContentLocale =>
  toContentLocale(useRouter().locale);
